// extracted by mini-css-extract-plugin
module.exports = {"input":"RusCS3","fields":"_2fSt36","ticketValidity":"_1j0hbO mz-default-dark-font"};